import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { BOLD_FONT_FAMILY } from '../../constants/constants';
import { ENTRY_PANEL_BACKGROUND_COLOR, ENTRY_PANEL_BORDER_COLOR } from '../../styles/colors';
import { lightTheme } from '../../styles/materialTheme';
const SECTION_CSS = css `
  display: flex;
  flex-direction: column;
  background-color: ${ENTRY_PANEL_BACKGROUND_COLOR};
  margin: 5px;
  padding: 15px 0px;
  border-radius: 10px;
  border: 4px solid ${ENTRY_PANEL_BORDER_COLOR};
  align-items: center;
  box-shadow: 15px 15px 0px 0px rgba(0, 0, 0, 0.2);
  // A bit hacky, define multiple identical CSS animations so they can be triggered
  // multiple times in a row (through alternating class name) and will be re-trigger the animation each time:
  &.glow-animation {
    animation: fadeOutAnimation 2s;
    @keyframes fadeOutAnimation {
      0% {
        background-color: white;
        border-color: white;
      }
      100% {
        background-color: ${ENTRY_PANEL_BACKGROUND_COLOR};
        border-color: ${ENTRY_PANEL_BORDER_COLOR};
      }
    }
  }
  &.glow-animation2 {
    animation: fadeOutAnimation2 2s;
    @keyframes fadeOutAnimation2 {
      0% {
        background-color: white;
        border-color: white;
      }
      100% {
        background-color: ${ENTRY_PANEL_BACKGROUND_COLOR};
        border-color: ${ENTRY_PANEL_BORDER_COLOR};
      }
    }
  }
`;
const TYPOGRAPHY_CSS = css `
  font-family: ${BOLD_FONT_FAMILY};
  font-size: 120%;
`;
export const EntryPanel = ({ title, ariaLabel, children }) => {
    return (_jsx(StyledEngineProvider, { injectFirst: true, children: _jsx(ThemeProvider, { theme: lightTheme, children: _jsxs("section", { "aria-label": ariaLabel, id: 'entry-panel', css: SECTION_CSS, children: [_jsx(Typography, { variant: 'h6', css: TYPOGRAPHY_CSS, children: _jsx("span", { css: TYPOGRAPHY_CSS, children: title }) }), children] }) }) }));
};
